import React, { Component } from 'react'
import { Popover, Modal, Input, Button, Upload, Radio, Icon } from 'antd'
import { app, api, config } from '../../../../app'
import InformationFilling from '../InformationFilling'
import AddTeamMembers from '../AddTeamMembers'
import AddNoSystemPerson from '../AddNoSystemPerson'
import UploadInformation from '../UploadInformation'
import html2canvas from 'html2canvas';



class Editor extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        // console.log(props)
        this.state = {
            modalInfo: props.modalInfo,
            componInfo1: {}, //申请人信息
            componInfo2: {}, //添加队员信息
            componInfo3: {}, //上传资料


            com1: [],
            com2: [],
            com3: {},

            addMember: false,
            application: false,

            // information:{}, //传给第一个组件的数据


            // 审核详情图片预览
            imgModal: false,     //预览弹窗
            showMoadlImg: '',     //当前所预览的图片
            imgListType: '',    //判断当前所预览的图片组
            infoType: ''     //判断当前所预览的数据组

        }
        // this.getInfo()

    }

    componentDidMount() {

    }




    // sendExamineInfo = () =>{
    //     if(this.props.examine != 1){
    //         return
    //     }

    //     const {information} = this.state;
    //     information.city_name = this.props.city_name
    //     information.teamname = this.props.teamname
    //     information.applicationManName = this.props.name
    //     information.applicationManId = this.props.idno
    //     information.applicationManPhone = this.props.mobile
    //     information.applicationManSex = this.props.sex
    //     information.type = this.props.type

    //     this.setState({
    //         information
    //     })
    // }
    putModalInfo = (e) =>{
        //一进入申请界面就返回数据
        this.setState({
            componInfo1: e
        })
    }

    // putModalInfo2 = (e) =>{
    //     //一进入申请界面就返回数据
    //     console.log(e)
    //     this.setState({
    //         componInfo2: e
    //     })
    // }

    // putModalInfo3 = (e) =>{
    //     //一进入申请界面就返回数据
    //     console.log(e)
    //     this.setState({
    //         componInfo3: e
    //     })
    // }

    // 组件1点击提交修改队伍信息
    compon1 = (e) => {
        const info = app.getData('InitialInfo')
        const { modalInfo } = this.state
        // console.log(modalInfo)

        

        console.log(e)
        
        app.post(api.TeamEditApply, {
            apply_name: info.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: modalInfo.id,
            name: e.applicationManName,
            idno: e.applicationManId,
            mobile: e.applicationManPhone,
            sms: e.MessageVerification,
            sex: e.applicationManSex,

        }).then(res => {
            console.log(res)
            if (res.flag == 1) {
                info.name = e.applicationManName
                info.idno = e.applicationManId
                info.mobile = e.applicationManPhone
                info.sex = e.applicationManSex
                info.sms = e.MessageVerification
                app.getData('InitialInfo', info)
                app.alert(res.msg, 'success', '45%')
                this.setState({
                    componInfo1: e
                })
                this.props.setComponentNum()
                this.props.EditorModalCencel()
                this.props.starLogin()
            } else {
                app.alert(res.msg, 'error', '45%')
            }
        })
    }

    compon2 = (e, type) => {
        const { componInfo2 } = this.state;
        componInfo2.volunteer_type = type;
        componInfo2.volunteer_json = JSON.stringify(e)
        // console.log(componInfo2)
        this.setState({
            componInfo2
        },()=>{
            app.alert('信息已提交，请点击【确认全部修改】保存数据', 'success', '45%')
        })
    }

    compon3 = (e) => {
        console.log(e)

        this.setState({
            componInfo3: e
        },()=>{
            app.alert('信息已提交，请点击【确认全部修改】保存数据', 'success', '45%')
        })
    }

    allUpdate = () => {
        const info = app.getData('InitialInfo')
        let modalInfo = this.state.modalInfo
        let componInfo1 = this.state.componInfo1
        let componInfo2 = this.state.componInfo2
        let componInfo3 = this.state.componInfo3
        console.log(componInfo1)

        let personal = componInfo3.personal_file_json
        let family = []
        componInfo3.personal_file_json.data.family.forEach((i, v) => {
            if (i.relation == '' || i.name == '' || i.work_unit == '' || i.mobile == '') {

            } else {
                family.push(componInfo3.personal_file_json.data.family[v])
            }

        })
        personal.data.family = family

        let work_exper = []
        componInfo3.personal_file_json.data.work_exper.forEach((i, v) => {
            if (i.name == '' || i.nature == '' || i.position == '' || i.join_time == '') {

            } else {
                work_exper.push(componInfo3.personal_file_json.data.work_exper[v])
            }

        })
        personal.data.work_exper = work_exper



        let prize = []
        componInfo3.personal_file_json.data.prize.forEach((i, v) => {
            if (i.unit == '' || i.name == '' || i.year == '') {

            } else {
                prize.push(componInfo3.personal_file_json.data.prize[v])
            }

        })
        personal.data.prize = prize



        

        app.post(api.TeamEdit, {
            apply_name: componInfo1.applicationManName,
            apply_mobile: componInfo1.applicationManPhone,
            apply_token: app.getData('apply_token'),
            prep_id: modalInfo.id,
            teamname: componInfo1.teamName,
            area_id: componInfo1.cascaderInfo[0],
            city_id: componInfo1.cascaderInfo[1],
            volunteer_type: componInfo2.volunteer_type,
            volunteer_json: componInfo2.volunteer_json,

            reg_file_json: JSON.stringify(componInfo3.reg_file_json),
            brand_file_json: JSON.stringify(componInfo3.brand_file_json),
            // brand_file_json:   JSON.stringify(brand_file_json),


            personal_file_json: JSON.stringify(personal),
            credit_file_json: JSON.stringify(componInfo3.credit_file_json),
            criminal_record_json: JSON.stringify(componInfo3.criminal_record_json),
            education_img: componInfo3.education_img,
            criminal_record_pro_img: componInfo3.criminal_record_pro_img

        }).then(res => {
            if (res.flag === 1) {
                this.props.getList()
                app.alert(res.msg, 'success', '45%')
            } else {
    
                app.alert(res.msg, 'error', '45%')
    
            }
        })
        
        this.setState({
            addMember:false,
            application:false
        })
        let familyInfo = {
            "relation": "",
            "name": "",
            "work_unit": "",
            "mobile": ""
        }
        let work_experInfo = {
            "name": "",
            "nature": "",
            "position": "",
            "join_time": ""
        }
        let prizeInfo = {
            "unit": "",
            "name": "",
            "year": ""
        }



        // console.log(data.prize.length)

        for (let i = 0; i = 3 - personal.data.family.length; i++) {
            personal.data.family.push(familyInfo)
        }
        for (let i = 0; i = 5 - personal.data.work_exper.length; i++) {
            personal.data.work_exper.push(work_experInfo)
        }
        for (let i = 0; i = 6 - personal.data.prize.length; i++) {
            personal.data.prize.push(prizeInfo)
        }
        
    }


    tixing = () =>{
        app.alert('请先【提交队员信息】和【提交申请资料】', 'error', '45%')

    }


    addMember = () => {
        this.setState({
            addMember: true
        })
    }

    application = () => {
        this.setState({
            application: true
        })
    }


    // 申请详情图片预览
    //打开图片弹窗和设置预览图片 showMoadlImg,设置当前所预览的图片组
    clickImg = (i, type, infoType) => {

        this.setState({
            imgModal: true,
            showMoadlImg: i,
            imgListType: type,
            infoType: infoType
        })
    };

    // 关闭图片弹窗
    clickImgCencel = () => {
        this.setState({
            imgModal: false
        })
    }


    lastImg = () => {
        let { imgListType, showMoadlImg, infoType } = this.state,imgList,index
        if (infoType == 'examineInfo') {
            if (imgListType == 'place_img') { //当前预览的是场地核查图片组
                imgList = this.props.examineInfo.place_img.split(';;;')
            } else { //当前预览的是装备核查图片组
                imgList = this.props.examineInfo.mall_img.split(';;;')
            }
        } else {
            if (imgListType == 'place_img') { //当前预览的是场地核查图片组
                imgList = this.props.applyinfo.place_img.split(';;;')
            } else { //当前预览的是装备核查图片组
                imgList = this.props.applyinfo.mall_img.split(';;;')
            }
        }

        imgList.forEach((i, v) => {
            if (i == showMoadlImg) { //如果所预览的图片有没有存在图片组中
                //判断如果当前图片所在的索引为0，那么就说明没有上一张了
                if (v == 0) {
                    index = v
                    app.alert("没有更多图片了", 'error', '45%')
                    return
                } else {
                    index = v
                }
            }
        })
        if (index == 0) {
            return
        } else {
            this.setState({
                showMoadlImg: imgList[index - 1]
            })
        }
    }


    nextImg = () => {
        let { imgListType, showMoadlImg,infoType } = this.state,imgList, index

        if (infoType == 'examineInfo') {    //如果当前为审核详情
            if (imgListType == 'place_img') { //当前预览的是场地核查图片组
                imgList = this.props.examineInfo.place_img.split(';;;')
            } else { //当前预览的是装备核查图片组
                imgList = this.props.examineInfo.mall_img.split(';;;')
            }
        } else {    //申请详情
            if (imgListType == 'place_img') { //当前预览的是场地核查图片组
                imgList = this.props.applyinfo.place_img.split(';;;')
            } else { //当前预览的是装备核查图片组
                imgList = this.props.applyinfo.mall_img.split(';;;')
            }
        }
        imgList.forEach((i, v) => {
            if (i == showMoadlImg) { //如果所预览的图片有没有存在图片组中
                //判断如果当前图片所在的索引为最后一张，那么就说明没有下一张了
                if (v == imgList.length - 1) {
                    index = v
                    app.alert("没有更多图片了", 'error', '45%')
                    return
                } else {
                    index = v
                }
            }
        })
        // console.log(index)
        if (index == imgList.length - 1) {
            return
        } else {
            this.setState({
                showMoadlImg: imgList[index + 1]
            })
        }
    }





    // 页面渲染区
    render() {
        // console.log(this.props)

        return (
            <div >
                <div>
                    <InformationFilling
                        examine={this.props.examine} //是否为审核
                        // information={this.state.information}    //审核详情数据
                        examineInfo={this.props.examineInfo}
                        id={this.state.modalInfo.id} //申请详情时使用的ID

                        com={1} //是否为申请详情

                        detailF={this.props.detailF}
                        apply={this.props.apply}   //申请详情
                        applyinfo={this.props.applyinfo}

                        Editor={false} 
                        compon1={this.compon1}
                        putModalInfo={this.putModalInfo} />

                </div>
                <p></p>
                <hr />
                <div >
                    <AddTeamMembers
                        examine={this.props.examine}
                        examineInfo={this.props.examineInfo}
                        apply={this.props.apply}   //申请详情
                        applyinfo={this.props.applyinfo}
                        com={1} id={this.state.modalInfo.id}
                        detailF={this.props.detailF}
                        Editor={false} com2={this.state.com2}
                        addMember={this.addMember}
                        compon2={this.compon2} />


                </div>
                <p></p>

                <hr />

                <div>
                    <UploadInformation examine={this.props.examine}
                        examineInfo={this.props.examineInfo}
                        apply={this.props.apply}   //申请详情
                        applyinfo={this.props.applyinfo}
                        detailF={this.props.detailF}
                        Editor={false}
                        com3={this.state.com3.file}
                        application={this.application}
                        compon3={this.compon3} />


                </div>



                {/* 详情 */}
                {/* 权限为二级时展示 */}



















                {/* 申请详情的审核内容展示 */}
                {/* 审核状态有三种：未审核，通过，不通过。三个都要展示不同的内容 */}
                {
                    this.props.apply == 1
                        ?
                        <div >
                            {/* 当前为审核详情时展示以下内容 */}
                            {/* 审核展示内容 */}
                            <div>
                                {/* 未审核 */}
                                <div>
                                    <h3 style={{ paddingBottom: 20 }}>督导官审核信息</h3>
                                    <div>
                                        {/* 根据applyinfo中的one_audit来判断当前展示的审核状态信息 */}
                                审核状态：<span style={{ color: '#00a9ff' }}>{this.props.applyinfo.one_audit == 0 ? '未审核' : (this.props.applyinfo.one_audit == 1 ? '审核通过' : '审核不通过')}</span>
                                    </div>

                                    {/* 申请详情督导官审核，场地和装备核查情况 */}
                                    <div hidden={this.props.applyinfo.one_audit != 1}>
                                        {/* 当一级审核状态为1，那么不隐藏当前组件 */}
                                        {/* 场地审核情况 */}
                                        <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                            场地核查情况：
                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>

                                                    <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                                        {
                                                            (this.props.applyinfo.place_img.split(';;;')).length >= 1 ? (this.props.applyinfo.place_img.split(';;;')).map(i => {
                                                                return (
                                                                    <Popover key={i} content={
                                                                        <div >
                                                                            <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={() => this.clickImg(i, 'place_img')} >预览</p>
                                                                        </div>
                                                                    }>

                                                                        <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                                    </Popover>

                                                                )
                                                            })
                                                                : <img style={{ width: 90, height: 100, margin: 2 }} alt="" />
                                                        }

                                                    </div>
                                                </div>


                                            </div>



                                        </div>

                                        {/* 装备核查情况 */}
                                        <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                            装备核查情况：
                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>

                                                    <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                                        {
                                                            (this.props.applyinfo.mall_img.split(';;;')).length >= 1 ? (this.props.applyinfo.mall_img.split(';;;')).map(i => {
                                                                return (
                                                                    <Popover key={i} content={
                                                                        <div >
                                                                            <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={() => this.clickImg(i, 'mall_img')}>预览</p>
                                                                        </div>
                                                                    }>

                                                                        <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                                    </Popover>

                                                                )
                                                            })
                                                                : <img style={{ width: 90, height: 100, margin: 2 }} alt="" />
                                                        }
                                                    </div>
                                                </div>


                                            </div>



                                        </div>

                                    </div>

                                    {/* 申请详情督导官审核，审核不通过返回审核理由 */}
                                    <div hidden={this.props.applyinfo.one_audit != 2} style={{ paddingTop: 20 }}>
                                        {/* 如果当前审核状态为审核不通过，那么当前组件不隐藏 */}
                                审核不通过原因：<span>{this.props.applyinfo.detail}</span>
                                    </div>

                                </div>

                                {/* 申请详情二级审核 */}
                                <div style={{ paddingTop: 50 }}>
                                    <h3 style={{ paddingBottom: 20 }}>二级审核信息</h3>
                                    <div>
                                        审核状态：<span style={{ color: '#00a9ff' }}>{this.props.applyinfo.two_audit == 0 ? '未审核' : (this.props.applyinfo.two_audit == 1 ? '审核通过' : '审核不通过')}</span>
                                    </div>

                                    {/* 通过，对筹备组备案作出评价 */}
                                    <div style={{ paddingTop: 20 }}>
                                        对筹备组备案通过作出评价：<span>{this.props.applyinfo.evaluate}</span>
                                    </div>

                                    {/* 不通过，审核不通过原因 */}
                                    <div hidden={this.props.applyinfo.two_audit != 2} style={{ paddingTop: 20 }}>
                                        {/* 如果当前审核状态为审核不通过，那么当前组件不隐藏 */}
                                审核不通过原因：<span>{this.props.applyinfo.detail}</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                        : ''

                }














                {/* 这是审核页面的审核详情 */}
                <div>
                    {
                        // 如果当前只审核了督导官审核，那么只展示督导官审核信息
                        this.props.audit_level == 1
                            ?
                            <div>
                                <h3 style={{ paddingBottom: 20 }}>
                                            督导官审核信息
                                        </h3>
                                <div>
                                    审核状态：<span style={{ color: '#00a9ff' }}>{this.props.examineInfo.one_audit_title}</span>
                                </div>
                                <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                    场地核查情况：
                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>

                                            <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                                {
                                                    this.props.examineInfo.place_img != '' ? (this.props.examineInfo.place_img.split(';;;')).map(i => {
                                                        return (
                                                            <Popover key={i} content={
                                                                <div >
                                                                    <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={() => this.clickImg(i, 'place_img', 'examineInfo')} >预览</p>
                                                                </div>
                                                            }>

                                                                <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                            </Popover>

                                                        )
                                                    })
                                                        : '无'
                                                }

                                            </div>
                                        </div>


                                    </div>



                                </div>

                                {/* 装备核查情况 */}
                                <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                    装备核查情况：
                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>

                                            <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                                {
                                                    this.props.examineInfo.mall_img != '' ? (this.props.examineInfo.mall_img.split(';;;')).map(i => {
                                                        return (
                                                            <Popover key={i} content={
                                                                <div >
                                                                    <p style={{ marginBottom: 20, cursor: 'pointer' }}  onClick={() => this.clickImg(i, 'mall_img', 'examineInfo')}>预览</p>
                                                                </div>
                                                            }>

                                                                <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                            </Popover>

                                                        )
                                                    })
                                                        : '无'
                                                }
                                            </div>
                                        </div>


                                    </div>



                                </div>

                                <div hidden={this.props.examineInfo.one_audit != 2}>
                                    审核不通过原因：{this.props.examineInfo.detail}
                                </div>




                                {/* 二级审核展示信息 */}
                                <div>
                                        <h3 style={{ paddingBottom: 20, paddingTop: 20 }}>
                                            二级审核信息
                                        </h3>
                                        <div style={{ paddingBottom: 20 }}>
                                            审核状态：<span style={{ color: '#00a9ff' }}>{this.props.examineInfo.two_audit_title}</span>
                                        </div>

                                    </div>


                            </div>
                            : this.props.audit_level == 2   //如果当前督导官和二级都审核了，那么展示督导官审核和二级审核信息
                                ?
                                <div>


                                    {/* 督导官展示信息 */}
                                    <div>
                                        <h3 style={{ paddingBottom: 20 }}>
                                            督导官审核信息
                                        </h3>
                                        <div>
                                            审核状态：<span style={{ color: '#00a9ff' }}>{this.props.examineInfo.one_audit_title}</span>
                                        </div>
                                        <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                            场地核查情况：
                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>

                                                    <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                                        {
                                                            (this.props.examineInfo.place_img.split(';;;')).length >= 1 ? (this.props.examineInfo.place_img.split(';;;')).map(i => {
                                                                return (
                                                                    <Popover key={i} content={
                                                                        <div >
                                                                            <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={() => this.clickImg(i, 'place_img', 'examineInfo')} >预览</p>
                                                                        </div>
                                                                    }>

                                                                        <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                                    </Popover>

                                                                )
                                                            })
                                                                : <img style={{ width: 90, height: 100, margin: 2 }} alt="" />
                                                        }

                                                    </div>
                                                </div>


                                            </div>



                                        </div>

                                        {/* 装备核查情况 */}
                                        <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                            装备核查情况：
                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>

                                                    <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                                        {
                                                            (this.props.examineInfo.mall_img.split(';;;')).length >= 1 ? (this.props.examineInfo.mall_img.split(';;;')).map(i => {
                                                                return (
                                                                    <Popover key={i} content={
                                                                        <div >
                                                                            <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={() => this.clickImg(i, 'mall_img', 'examineInfo')}>预览</p>
                                                                        </div>
                                                                    }>

                                                                        <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                                    </Popover>

                                                                )
                                                            })
                                                                : <img style={{ width: 90, height: 100, margin: 2 }} alt="" />
                                                        }
                                                    </div>
                                                </div>


                                            </div>



                                        </div>

                                        <div hidden={this.props.examineInfo.one_audit != 2}>
                                            审核不通过原因：{this.props.examineInfo.detail}
                                        </div>


                                    </div>







                                    {/* 二级审核展示信息 */}
                                    <div>
                                        <h3 style={{ paddingBottom: 20, paddingTop: 20 }}>
                                            二级审核信息
                                        </h3>
                                        <div style={{ paddingBottom: 20 }}>
                                            审核状态：<span style={{ color: '#00a9ff' }}>{this.props.examineInfo.two_audit_title}</span>
                                        </div>

                                        {/* 评价 */}
                                        {/* 如果当前二级评论为通过，那么展示以下内容 */}
                                        <div style={{ display: 'flex', alignItems: 'center' }} hidden={this.props.examineInfo.two_audit != 1}>
                                            对筹备组备案通过作出评价：
                                            <div >
                                                {/* style={{ display: 'flex', justifyContent: 'space-around' }} */}

                                                {
                                                    this.props.examineInfo.evaluate
                                                }

                                            </div>

                                        </div>
                                        {/* 不通过原因 */}
                                        {/* 如果当前二级评论为不通过通过，那么展示以下内容 */}
                                        <div hidden={this.props.examineInfo.two_audit != 2}>
                                            审核不通过原因：{this.props.examineInfo.detail}
                                        </div>


                                    </div>
                                </div> : ''
                    }
                </div>


                {/* 图片预览,申请详情和审核详情共用 */}


                <Modal visible={this.state.imgModal} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.clickImgCencel}>
                    <p style={{ display: 'flex', justifyContent: 'space-around', color: '#1890ff', fontWeight: 'bold' }}>
                        <div style={{ cursor: 'pointer' }} onClick={this.lastImg}>
                            <Icon type="left" ></Icon> 上一张
                                    </div>
                        <div style={{ cursor: 'pointer' }} onClick={this.nextImg}>
                            下一张<Icon type="right" ></Icon>
                        </div>
                    </p>
                    {

                        <img src={config.imgUrl + this.state.showMoadlImg} alt="" style={{ width: 1000 }} />
                    }
                </Modal>




                <div style={{ paddingTop: 80, display: 'flex', justifyContent: 'center' }} >
                    {/* 如果当前审核详情中已经审核了督导官审核和二级审核，那么就不再展示前往审核按钮 audit_level == 2 */}
                    <Button style={{ width: 300, color: '#1890FF', marginRight: 30 }} onClick={()=>this.props.EditorModalCencel()}>关闭</Button>

                    {
                        this.props.detailF == 1 ? '' : this.props.examine == 1
                            ? <Button style={{ width: 300, backgroundColor: '#1890FF', color: '#fff' }} onClick={() => this.props.goExamine(this.props.examineInfo)} hidden={this.props.examineInfo.audit_level == 2}>前往审核</Button>
                            : this.state.addMember && this.state.application ? <Button style={{ width: 300, backgroundColor: '#1890FF', color: '#fff' }} onClick={this.allUpdate}>确认全部修改</Button> : <Button style={{ width: 300, color: '#000' }} onClick={this.tixing}>全部提交</Button>
                    }

                </div>
            </div>
        )
    }
}



export default Editor



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/UploadInformationModal/Editor.jsx